import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CongressContainerContactInfoConverter extends CmsConverterService<CongressContainerContactInfoData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      headline: formData.st_contact_headline ?? defaultTextInput,
      text: formData.st_contact_text ?? defaultTextInput,
      elements: formData.st_container ?? defaultFSCatalog
    }
  }
}

export const CONGRESS_CONTAINER_CONTACT_INFO_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, CongressContainerContactInfoData>>('CongressContainerContactInfoConverter')

export interface CongressContainerContactInfoData extends ConvertedComponentData {
  headline: TextInput;
  text: TextInput;
  elements: FsCatalog;
}
